import RecordsCard from "./RecordsCard";

function RecordsSection({ title, subtitle, cards = [] }) {
    if (!cards.length) {
        return null;
    }

    return (
        <section className="mb-16">
            <div className="flex flex-col items-center gap-3 sm:gap-4 mb-8">
                <div className="h-px bg-white/10 w-full sm:flex-grow"></div>
                <h2 className="text-xl font-bold text-white uppercase tracking-[0.12em] sm:tracking-[0.2em] text-center whitespace-normal break-words leading-tight max-w-full px-2">{title}</h2>
                {subtitle ? (
                    <p className="text-sm text-slate-400 font-medium text-center -mt-2">{subtitle}</p>
                ) : null}
                <div className="h-px bg-white/10 w-full sm:flex-grow"></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 items-start gap-8">
                {cards.map((card) => (
                    <RecordsCard
                        key={card.id}
                        title={card.title}
                        rows={card.rows}
                        noDecimals={card.noDecimals}
                    />
                ))}
            </div>
        </section>
    );
}

export default RecordsSection;
